import {Component,EventEmitter,ViewChild,Output,ElementRef,} from "@angular/core";
import { MatTableDataSource,DateAdapter,MAT_DATE_LOCALE,MAT_DATE_FORMATS, } from "@angular/material";
import { DatePipe } from "@angular/common";
import {MessagesGeneral,MessagesTitles,MessagesStatus,} from "../../../../models/messages";
import { LiquidacionService } from "../../../../services/liquidacion/liquidacion.service";
import { MomentDateAdapter } from "@angular/material-moment-adapter";

import {
  FormBuilder,
  FormGroup,
} from "@angular/forms";
import { environment } from "environments/environment";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY",
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-generar-liquidacion",
  templateUrl: "./generar-liquidacion.component.html",
  styleUrls: ["./generar-liquidacion.component.scss"],
  providers: [
    DatePipe,
    MessagesTitles,
    MessagesGeneral,
    MessagesStatus,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class GenerarLiquidacionComponent  {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  exampleForm: FormGroup;
  ejemplo: any;
  datosEnviar2: any = [];
  user:any;
  loading: boolean = false;
  idDesembolso: any;
  datosEnviar: any= [] ;
  dataSource: any;
  dataLiquidacion: any;
  arrayLiquidacion:any;
  data:any;
  checkboxStates = {}
  proveedor:any;
  adquirente:any;
  fechaLiquidacion: Date = new Date();
  idComprobante:any
  form : FormGroup;

  @Output() cerrarGenerarLiquidacion = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<any>();

  @ViewChild("TABLE", { static: true }) table: ElementRef;
  displayedColumns: string[] = [
    "Serie",
    "Numero",
    "Moneda",
    "Tipo_Comprobante",
    "Tipo_Emision",
    "Estado",
    "VNPP",
  ];

  constructor(
    private liquidacionService: LiquidacionService,
    private msgTitulos: MessagesTitles,
    private datePipe: DatePipe,
    private msgStatus: MessagesStatus,
    private formBuilder: FormBuilder
  ) {
    
    this.arrayLiquidacion = this.liquidacionService.arrayLiquidacion;
    this.datosEnviar2 = this.liquidacionService.arrayLiquidacion;

    this.idComprobante = this.liquidacionService.arrayLiquidacion[0].idComprobante
  
     this.proveedor = this.arrayLiquidacion[0].Proveedor ;
     this.adquirente = this.arrayLiquidacion[0].Adquirente; 
     
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.dataSource = new MatTableDataSource(this.arrayLiquidacion);
  }



  CerrarPopUp() {
    this.cerrarGenerarLiquidacion.emit();
  }
}
